import React from 'react';
import { Box, Typography, Stack, Tooltip } from '@mui/material';
import { typographyStyles, chipStyles } from '../../../modals/unified_config_modals/styles/unifiedConfigStyles';
import { AlertOptions as GeneratedAlertOptions } from '@/../generated-client/models';
import { ALERT_OPTIONS_LABELS } from '@/utils/unified_config_helper/alertOptionsLabels';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '@/resources/strings/StringKeys';

interface Props {
  label: string;
  value: GeneratedAlertOptions;
  setValue: (v: GeneratedAlertOptions) => void;
}

export const AlertsSection: React.FC<Props> = ({ label, value, setValue }) => {
  const { t } = useTranslation();
  const selected = value;

  const getDescriptions = (): Record<number, string> => ({
    [GeneratedAlertOptions.NUMBER_0]: t(StringKeys.WORKER_CAN_CHOOSE_TO_ENABLE_OR_DISABLE_THIS_SETTING),
    [GeneratedAlertOptions.NUMBER_1]: `(${t(StringKeys.LOCKED)}) ${t(StringKeys.WORKER_CANNOT_EDIT_SETTING)}`,
    [GeneratedAlertOptions.NUMBER_2]: `(${t(StringKeys.LOCKED)}) ${t(StringKeys.WORKER_CANNOT_EDIT_SETTING)}`,
  });

  const getDescription = (v: GeneratedAlertOptions | number): string => {
    const descriptions = getDescriptions();
    const desc = descriptions[v];
    if (!desc) {
      console.error(`Invalid AlertOptions value received: ${v}`);
      return t(StringKeys.UNKNOWN_ALERT_OPTION);
    }
    return desc;
  };

  const handleSelect = (option: number) => {
    setValue(option as GeneratedAlertOptions);
  };

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={typographyStyles.sectionHeading}>{label}</Typography>
      <Box sx={{ py: 2 }}>
        <Stack direction="row" spacing={2}>
          {ALERT_OPTIONS_LABELS.map((opt) => (
            <Tooltip
              key={opt.value}
              title={getDescription(opt.value)}
              placement="bottom"
              arrow
              slotProps={{ popper: { sx: { zIndex: 2100 } } }}
            >
              <Box
                onClick={() => handleSelect(opt.value)}
                sx={chipStyles.alertOptionChip(selected === opt.value)}
              >
                {t(opt.labelKey)}
              </Box>
            </Tooltip>
          ))}
        </Stack>
        <Typography variant="body2" sx={typographyStyles.alertDescription}>
          {getDescription(selected)}
        </Typography>
      </Box>
    </Box>
  );
};
